export enum CampagneUserTypeEnum {
  organisateur = 'organisateur',
  responsable = 'responsable'
}
